// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1O9X5","boxTitle":"Qualiphy_boxTitle__3mi1v","box":"Qualiphy_box__eyxDO","toggleWrap":"Qualiphy_toggleWrap__1Wlfj"};